import { combineReducers, configureStore } from "@reduxjs/toolkit";
import { persistReducer, persistStore } from "redux-persist";
import storage from "redux-persist/lib/storage";
import { FLUSH, REHYDRATE, PAUSE, PERSIST, PURGE, REGISTER } from "redux-persist";
import loginData from "./auth/loginDataSlice";
import auth from "./auth/loginSlice";
import cartRefresh from "./auth/cartRefreshSlice";
import navCounts from "./auth/navCountSlice";

const persistConfig = {
  key: "root",
  storage,
  whitelist: ["auth", "loginData"],
};

const rootReducer = combineReducers({
  auth,
  loginData,
  cartRefresh,
  navCounts,
});

const persistedReducer = persistReducer(persistConfig, rootReducer);

const store = configureStore({
  reducer: persistedReducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: {
        ignoredActions: [FLUSH, REHYDRATE, PAUSE, PERSIST, PURGE, REGISTER],
      },
    }),
});

const persistor = persistStore(store);

export { store, persistor };
